module.exports = __webpack_public_path__ + "010cdaff672cf8712745c84b3a54e2a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-30.png
// module id = 1185
// module chunks = 0